export default (host: string) => ({
  '@id': 'organization',
  'address': {
    '@type': 'PostalAddress',
    'addressCountry': 'CH',
    'addressLocality': 'Stabio',
    'addressRegion': 'Ticino',
    'postalCode': '6855',
    'streetAddress': 'Via Laveggio 5'
  },
  'areaServed': 'BE',
  'brand': {
    '@type': 'Brand',
    '@id': `https://${host}/de-be#brand`,
    'name': 'Timberland',
    'description': 'Timberland - für Mutige und Abenteurer. Wir haben die Vision, „Abenteurer“ auszustatten und zu inspirieren, nach draußen zu gehen, intensiv zu arbeiten und die Welt zu verbessern.',
    'url': `https://${host}/de-be`,
    'image': `https://${host}/img/logo50.svg`
  },
  'contactPoint': [
    {
      '@type': 'ContactPoint',
      'telephone': '+32 0800 180 0182',
      'contactType': 'Telephone',
      'areaServed': 'BE',
      'hoursAvailable': 'Mo,Tu,We,Th,Fr 09:00-19:00 CET'
    },
    {
      '@type': 'ContactPoint',
      'contactType': 'Chat',
      'areaServed': 'BE',
      'hoursAvailable': 'Mo,Tu,We,Th,Fr 09:00-19:00 CET',
      'url': `https://${host}/de-be`
    }
  ],
  'logo': {
    '@id': '#logo',
    'caption': 'Timberland',
    'contentUrl': `https://${host}/img/logo50.svg`,
    'url': `https://${host}/img/logo50.svg`
  },
  'name': 'Timberland',
  'parentOrganization': 'VF Corporation (VFC)',
  'sameAs': [
    'https://www.youtube.com/timberland',
    'https://www.instagram.com/timberland',
    'https://www.facebook.com/timberland'
  ],
  'url': `https://${host}/de-be`
})
